import { UseAxiosResult } from "axios-hooks";
import formatUrl from "utils/formatUrl";

import api from "config/urls/api";

import { UseManageUserManagementApi } from "./setup";

export const usePermissionsQuery = (): UseAxiosResult<string[]> => {
  return UseManageUserManagementApi<string[]>({
    url: formatUrl(api.manage.permissions.all),
    method: "GET",
  });
};
